import http from '@/libs/http'

export function DetailOrder (orderId) {
  return http.get('crm/financeorder/detail', { params: { id: orderId } }).then((resp) => {
    if (resp.deliveries && resp.deliveries.length) {
      resp.deliveries.forEach((pack) => {
        pack.images = pack.deliveryImages ? pack.deliveryImages.split(',') : []
      })
    }
    return resp
  })
}

export function ListOrder (queryModel) {
  return http.get('crm/financeorder/pagequery', { params: queryModel })
}

export function ListRefund (queryModel) {
  queryModel.taxed = 1
  queryModel.subSellerId = 0
  return http.get('crm/order/refundlist', { params: queryModel })
}

export function QueryInvoiceDetail (invoiceId) {
  return http.get('crm/financeorder/invoicedetail', { params: { invoiceId } })
}
